import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DispatchBoardPanels } from "../../shared/enums/DispatchBoardPanels";
import { DispatchBoardService } from '../../shared/services/dispatch-board.service';
import { DispatchBoardSearch } from '../../shared/models/DispatchBoardSearch';
import { GlobalsService } from '../../shared/services/globals.service';

@Component({
    selector: 'cp-dispatch-board-widget-tech',
    templateUrl: './dispatch-board-widget-tech.component.html',
    styleUrls: ['./dispatch-board-widget-tech.component.scss']
})
export class DispatchBoardWidgetTechComponent implements OnInit {

    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService) { }

    @Input() filterString: string = '';
    @Input() parentPanel: DispatchBoardPanels;
    @Input() inputData: any = { description: 'Title', value: '000' };
    data: any = [];

    showContactFlag: boolean = false;
    waitover: boolean = false;
    ngOnInit() {
        //if (this.inputData.personId) {
        //    this.svc_data.getTechAssignments(this.inputData.personId).subscribe(data => {
        //        this.data.push(data);

        //        if (data && data.error) {
        //            alert('got an error back!');
        //        }

        //    });
        //}
    }
    public popupClass: string = 'cp-light-popup';
    @Output() popupLock = new EventEmitter<boolean>();

    public lockPopups(lock: boolean) {
        this.popupLock.emit(lock);
    }

    showContactHover(state: boolean) {
        var _this = this;
        if (state) {
        setTimeout(function () {
            if (_this.showContactFlag ) {

                _this.waitover=true;
            }
        }, 500);
        }
        this.waitover = false;
        this.showContactFlag = state;

    }

	sampleMenu: Array<any> = [{
		text: 'Move',
		icon: 'arrows-alt'
	}, {
		text: 'Hide',
		icon: 'eye-slash'
	}, {
		text: 'View Dispatches',
		icon: 'th'
	}];
}

